module.exports = __webpack_public_path__ + "static/media/NSS.d7e2ecf7.png";